import HOOK from "../hooks"
import { COLUMN } from "../../modules/constants"
import { CHECKBOX } from "../../modules/checkbox_constants"

const statObj = () => ({ mean: null, numof: 0, total: null })

const getApptsCount = () => {
  let apptsCount = []

  for (let tense = 0; tense < CHECKBOX[HOOK.TENSE].length; ++tense)
    apptsCount.push(statObj())

  return apptsCount
}

const initStats = () => {
  return {
    numRows: 0,
    numRoles: 0,
    countries: statObj(),
    employees: statObj(),
    marketCap: statObj(),
    revenue: statObj(),
    tenure: statObj(),
    tenureYears: statObj(),
    compensation: statObj(),
    age: statObj(),
    sex: statObj(),
    apptsCount: getApptsCount(),

    ac: statObj(),
    am: statObj(),
    rc: statObj(),
    rm: statObj(),
    nc: statObj(),
    nm: statObj(),

    adviserClient: statObj(),
    asAuditor: statObj(),
    asRecruitingAdviser: statObj(),
    asRemunerationAdviser: statObj(),
    asExternalReviewer: statObj(),
    totalClients: statObj(),
  }
}

const iterate = (object, stats, value) => {
  for (const prop in object)
    if (typeof object[prop] === "object")
      iterate(object[prop], stats, value)
    else
      stats[object[prop]] = value()
}

export const initStats2 = stats2 => {
  iterate(COLUMN, stats2, statObj)

  // TODO Find an alternative - better - column id than apptsCount
  stats2.apptsCount = getApptsCount()
  return stats2
}

export default initStats